import * as LabelPrimitive from '@radix-ui/react-label'
import type { ReactNode } from 'react'

export interface FieldProps {
  label: string
  hint?: string
  /** Omit when the control has no focusable element carrying an id. */
  htmlFor?: string
  children: ReactNode
}

/** One settings row. Separators are the parent's job, so rows compose cleanly. */
export function Field({ label, hint, htmlFor, children }: FieldProps): ReactNode {
  return (
    <div className="flex items-center justify-between gap-4 py-2">
      <div className="min-w-0">
        <LabelPrimitive.Root htmlFor={htmlFor} className="text-[12px] text-fg">
          {label}
        </LabelPrimitive.Root>
        {hint ? (
          <p className="mt-0.5 text-[11px] leading-snug break-words text-fg-muted">{hint}</p>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center">{children}</div>
    </div>
  )
}
